/* eslint-disable import/prefer-default-export */
export const ssr = true;
// export const prerender = false;
